import React from "react";
import dayjs from "dayjs";
import useSystemUser from "../../../Core/hooks/useSystemUser";
import getDateAndTime from "../../../Utils/getDateAndTime";
import CustomTooltip from "../../../Core/Components/CustomTooltip";

export const DateOfEntryColumn = ({ record }) => {
  const submittedBy = useSystemUser(record.submittedBy);
  const dateAndTime = getDateAndTime(record.submittedAt);

  return (
    <CustomTooltip tooltipTitle={`As on ${dateAndTime}`} placement="topLeft">
      <div>
        <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
          {submittedBy}
        </div>
        <div className="text-10 font-light font-aileron leading-3.75 text-dark-gray">
          {record?.submittedAt
            ? dayjs(record.submittedAt).format("DD-MM-YYYY")
            : "--"}
        </div>
      </div>
    </CustomTooltip>
  );
};
